import { Tag, TagProps } from "@p0security/ui";
import classNames from "classnames";
import { PropsWithChildren } from "react";

/**
 * The Tags in this file are wrappers around the AntD tags with styling and colors
 * @param content The text to display inside the tags
 */
export const StyledTag: React.FC<
  PropsWithChildren<
    Omit<TagProps, "color"> & {
      color: {
        bg: string;
        text: string;
      };
      ellipsis?: boolean;
    }
  >
> = ({ children, ellipsis, ...props }) => {
  const tagProps = {
    ...props,
    className: classNames(props.className, {
      "overflow-hidden text-ellipsis whitespace-nowrap": ellipsis,
    }),
    color: props.color.bg,
    style: { ...props.style, color: props.color.text },
  };
  return <Tag {...tagProps}>{children}</Tag>;
};
